__turbopack_context__.v({
  "pageContainer": "Company-module-scss-module__bYcelq__pageContainer",
});
